<template lang="pug">
//- 親コンポーネントでイベント管理したいので、click.stopは常につけること
.questionnaire-item-component.mb-3(:class="{ 'focused': value.isFocused }")
  //- type: text
  .template-item.d-flex.flex-column(v-if="isText(value)")
    .focused(v-show="value.isFocused == true")
      //- control
      .control-area.d-flex.flex-row.justify-content-end.mb-3
        .arrow-down-icon.mr-3(@click.stop="onMoveDown" :class="{ 'disable': disableMoveDown }")
        .arrow-up-icon.mr-3(@click.stop="onMoveUp" :class="{ 'disable' : disableMoveUp }")
        .trash-icon(@click.stop="onDelete")
      //- title
      .d-flex.flex-row.align-items-center
        .no {{ index + 1 }}.
        b-form-input(v-model="value.title" :id="'title-' + index" :name="'title-' + index" placeholder="質問"
          :maxlength="100" v-validate="{ required: true, max: 100 }" data-vv-as="タイトル")
      .error-messages.mt-1(v-if="errors.has('title-' + index)" style="padding-left:34px;")
        label.error-message(v-for="error in errors.collect('title-' + index)") {{ error }}
      .mb-3
      //- answer
      .d-flex.text-answer(v-if="value.isLong == true")
        b-form-textarea.disable.mb-3(v-model="value.answer" :id="'answer-' + index" :name="'answer-' + index" placeholder="回答を入力してください" rows="3" disabled)
      .d-flex.text-answer(v-if="value.isLong == false")
        b-form-input.disable.mb-3(v-model="value.answer" :id="'answer-' + index" :name="'answer-' + index" placeholder="回答を入力してください" disabled)
      //- checkboxs
      .d-flex.flex-row.align-items-center.justify-content-end
        b-form-checkbox.mr-3(v-model="value.isLong" :id="'isLong-' + index" :name="'isLong-' + index" switch) 長い回答
        b-form-checkbox(v-model="value.required" :id="'required-' + index" :name="'required-' + index" switch) 必須
    .nofocused(v-if="value.isFocused == false")
      //- title
      .d-flex.flex-row.align-items-center
        .no {{ index + 1 }}.
        span.mr-1 {{ value.title }}
        span.validation-label(v-if="value.required == true") 必須
      .error-messages.mt-1(v-if="errors.has('title-' + index)" style="padding-left:34px;")
        label.error-message(v-for="error in errors.collect('title-' + index)") {{ error }}
      .mb-3
      //- answer
      .d-flex.text-answer(v-if="value.isLong == true")
        b-form-textarea.disable.mb-3(v-model="value.answer" :id="'answer-' + index" :name="'answer-' + index" placeholder="回答を入力してください" rows="3" disabled)
      .d-flex.text-answer(v-if="value.isLong == false")
        b-form-input.disable.mb-3(v-model="value.answer" :id="'answer-' + index" :name="'answer-' + index" placeholder="回答を入力してください" disabled)

  //- type: select
  .template-item.d-flex.flex-column(v-if="isSelect(value)")
    .focused(v-show="value.isFocused == true")
      //- control
      .control-area.d-flex.flex-row.justify-content-end.mb-3
        .arrow-down-icon.mr-3(@click.stop="onMoveDown" :class="{ 'disable': disableMoveDown }")
        .arrow-up-icon.mr-3(@click.stop="onMoveUp" :class="{ 'disable' : disableMoveUp }")
        .trash-icon(@click.stop="onDelete")
      //- title
      .d-flex.flex-row.align-items-center
        .no {{ index + 1 }}.
        b-form-input(v-model="value.title" :id="'title-' + index" :name="'title-' + index" placeholder="質問"
          :maxlength="100" v-validate="{ required: true, max: 100 }" data-vv-as="タイトル")
      .error-messages.mt-1(v-if="errors.has('title-' + index)" style="padding-left:34px;")
        label.error-message(v-for="error in errors.collect('title-' + index)") {{ error }}
      .mb-3
      //- options
      .d-flex.flex-column.mb-3(v-for="(option, optionIndex) in value.options")
        .d-flex.flex-row.align-items-center.select-option
          img.mr-2(v-if="value.multiple == false" src="@/assets/component-icons/radio-on-selected.svg")
          img.mr-2(v-if="value.multiple == true" src="@/assets/component-icons/check-on-selected.svg")
          b-form-input.select-option-item.mr-2(v-model="option.text" :id="'select-option-' + index + '-' + optionIndex"
            :name="'select-option-' + index + '-' + optionIndex" placeholder="オプション名を入力します。"
            :maxlength="100" v-validate="{ required: true, max: 100 }" data-vv-as="オプション名")
          .trash-icon.mr-3(@click.stop="onOptionDelete(optionIndex)")
        .error-messages.mt-1(v-if="errors.has('select-option-' + index + '-' + optionIndex)" style="padding-left:34px;")
          label.error-message(v-for="error in errors.collect('select-option-' + index + '-' + optionIndex)") {{ error }}
      .d-flex.select-option-buttons.mb-3
        a.add-option-btn(@click.stop="onAddSelectOption" :disabled="_disableAddOptionBtn" :class="{ 'disable': _disableAddOptionBtn }") ＋選択肢を追加
      //- checkboxs
      .d-flex.flex-row.justify-content-end
        b-form-checkbox.mr-3(v-model="value.multiple" :id="'multiple-' + index" :name="'multiple-' + index" switch) 複数回答
        b-form-checkbox(v-model="value.required" :id="'required-' + index" :name="'required-' + index" switch) 必須
    .nofocused(v-if="value.isFocused == false")
      //- title
      .d-flex.flex-row.align-items-center
        .no {{ index + 1 }}.
        span.mr-1 {{ value.title }}
        span.validation-label(v-if="value.required == true") 必須
      .error-messages.mt-1(v-if="errors.has('title-' + index)" style="padding-left:34px;")
        label.error-message(v-for="error in errors.collect('title-' + index)") {{ error }}
      .mb-3
      //- options
      .d-flex.flex-column.mb-3(v-for="(option, optionIndex) in value.options")
        .d-flex.flex-row.align-items-center.select-option
          img.mr-2(v-if="value.multiple == false" src="@/assets/component-icons/radio-on-selected.svg")
          img.mr-2(v-if="value.multiple == true" src="@/assets/component-icons/check-on-selected.svg")
          span {{ option.text }}
        .error-messages.mt-1(v-if="errors.has('select-option-' + index + '-' + optionIndex)" style="padding-left:34px;")
          label.error-message(v-for="error in errors.collect('select-option-' + index + '-' + optionIndex)") {{ error }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { QuestionnaireSelectItemOption, QuestionTemplateItem, TemplateType } from "@/commons/services/Questionnaires";

import ChildItem from "@/pc/containers/questionnaires/QuestionInputItem.vue";

/**
 * ### アンケートアイテムコンポーネント
 */
@Component({
  components: {
    ChildItem
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "QuestionInputItem"
})
export default class QuestionInputItem extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** テンプレート情報 */
  @Prop({ required: true })
  value!: QuestionInputItemModel;

  /** インデックス */
  @Prop({ required: true })
  index!: number;
  /** 「下へ移動」ボタンが非活性か否か */
  @Prop({ required: true })
  disableMoveDown!: boolean;
  /** 「上へ移動」ボタンが非活性か否か */
  @Prop({ required: true })
  disableMoveUp!: boolean;

  get _disableAddOptionBtn(): boolean {
    const selectItem: QuestionInputSelectItemModel = this.value as QuestionInputSelectItemModel;
    if (selectItem.options.length < 50) {
      return false;
    } else {
      return true;
    }
  }

  public setFocus(focus: boolean): void {
    this.value.isFocused = focus;
    return;
  }

  public isText(item: QuestionInputItemModel): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public isSelect(item: QuestionInputItemModel): boolean {
    if (item.type != TemplateType.SELECT) {
      return false;
    }
    return true;
  }

  public onDelete(): void {
    this.$emit("onDelete", this.index);
    return;
  }

  public onMoveDown(): void {
    this.$emit("onMoveDown", this.index);
    return;
  }

  public onMoveUp(): void {
    this.$emit("onMoveUp", this.index);
    return;
  }

  public onOptionDelete(optionIndex: number): void {
    this.$emit("onOptionDelete", { index: this.index, optionIndex: optionIndex });
    return;
  }

  public onAddSelectOption(): void {
    const selectItem: QuestionInputSelectItemModel = this.value as QuestionInputSelectItemModel;
    if (50 <= selectItem.options.length) {
      return;
    }
    this.$emit("onAddSelectOption", this.index);
    return;
  }
}

export interface QuestionInputItemModel extends QuestionTemplateItem {
  /** フォーカスがあたっているか否か */
  isFocused: boolean;
}
export interface QuestionInputTextItemModel extends QuestionInputItemModel {
  /** 見出し(最大 100 文字) */
  title: string;
  /** 回答入力用のプロパティ。回答内容(最大 1000 文字) */
  answer: string;
  /** 長い回答か否か */
  isLong: boolean;
  /** 必須入力か否か */
  required: boolean;
}
export interface QuestionInputSelectItemModel extends QuestionInputItemModel {
  /** 見出し(最大 100 文字) */
  title: string;
  /** 回答入力用のプロパティ。回答内容の配列 */
  answer: string[];
  /** 質問内容の配列 */
  options: Array<QuestionnaireSelectItemOption>;
  /** 複数回答可能か否か */
  multiple: boolean;
  /** 必須入力か否か */
  required: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.questionnaire-item-component {
  border-radius: 0.25rem;
  padding: 12px;

  background: rgba(246, 246, 246, 1) 0% 0% no-repeat padding-box;

  &.focused {
    border: 1px solid $font-key-color;
    // background-color: rgba(232, 243, 245, 1) !important;
    background: linear-gradient(180deg, rgba(213, 235, 238, 1) 0px, rgba(213, 235, 238, 1) 50px, rgba(232, 243, 245, 1) 50px, rgba(232, 243, 245, 1) 100%) !important;

    &:hover {
      background-color: rgba(232, 243, 245, 1) !important;
    }
  }

  &:hover {
    background-color: rgba(232, 243, 245, 1) !important;
    transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
  }

  .control-area {
    height: 50px;
  }

  .no {
    width: 34px;
    font-weight: bold;
  }

  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
    background-color: #fff;
  }

  .text-answer,
  .select-option,
  .select-option-buttons {
    margin-left: 32px;

    .btn {
      height: 38px !important;
    }
  }

  .select-option {
    .select-option-item {
      width: 300px;
      max-width: 300px;
    }
  }

  .arrow-down-icon {
    @include svg-icon("../../../assets/arrow-down.svg", $btn-font-disable, 24px, 24px);
    &:hover {
      @include svg-icon("../../../assets/arrow-down.svg", $font-key-color, 24px, 24px);
    }
    &.disable {
      cursor: not-allowed;
      @include svg-icon("../../../assets/arrow-down.svg", rgba(188, 188, 188, 1), 24px, 24px);
    }
  }
  .arrow-up-icon {
    @include svg-icon("../../../assets/arrow-up.svg", $btn-font-disable, 24px, 24px);
    &:hover {
      @include svg-icon("../../../assets/arrow-up.svg", $font-key-color, 24px, 24px);
    }
    &.disable {
      cursor: not-allowed;
      @include svg-icon("../../../assets/arrow-up.svg", rgba(188, 188, 188, 1), 24px, 24px);
    }
  }
  .trash-icon {
    @include svg-icon("../../../assets/trash.svg", $btn-font-disable, 24px, 24px);
    &:hover {
      @include svg-icon("../../../assets/trash.svg", $font-key-color, 24px, 24px);
    }
    &.disable {
      cursor: not-allowed;
      @include svg-icon("../../../assets/trash.svg", rgba(188, 188, 188, 1), 24px, 24px);
    }
  }

  .add-option-btn {
    font-size: 20px !important;
    color: $font-key-color;
    cursor: pointer;

    &.disable {
      cursor: not-allowed;
      color: rgba(188, 188, 188, 1) !important;
    }
  }

  .delete-btn {
    font-size: 14px !important;
    width: 50px;
    height: 38px !important;
  }
}
</style>
